const BLOCKED_MIME = new Set([
  'application/x-msdownload',
  'application/x-msdos-program',
  'application/vnd.microsoft.portable-executable',
  'application/x-dosexec',
  'application/x-mach-binary',
  'application/x-executable',
  'application/x-sharedlib',
  'application/x-object',
  'application/vnd.android.package-archive',
  'application/x-msi',
  'application/x-apple-diskimage',
  'application/x-rpm',
  'application/vnd.debian.binary-package',
  'application/x-elc',
  'application/x-sh',
  'application/x-bash',
  'application/x-zsh',
  'application/x-binary',
  'application/macbinary',
  'application/powershell',
  'text/powershell',
  'application/octet-stream',
  'text/x-msdos-batch',
  'application/java-archive',
  'application/x-java-archive',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-word.template.macroEnabled.12',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
]);

export const COMMON_IMAGE_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/svg+xml',
  'image/heic',
  'image/heif',
  'image/avif'
]);

const BLOCKED_EXT = new Set([
  '.exe',
  '.dll',
  '.bat',
  '.cmd',
  '.msi',
  '.scr',
  '.pif',
  '.com',
  '.apk',
  '.elf',
  '.so',
  '.dylib',
  '.bin'
]);

export const isAllowed = (mime: string, filename: string) => {
  if (BLOCKED_MIME.has(mime)) {
    return false;
  }

  const ext = filename.toLowerCase().slice(filename.lastIndexOf('.'));
  if (BLOCKED_EXT.has(ext)) return false;

  return (
    mime === 'application/octet-stream' ||
    mime.startsWith('image/') ||
    mime.startsWith('audio/') ||
    mime.startsWith('video/') ||
    mime.startsWith('text/') ||
    mime.startsWith('application/')
  );
};
